import React, { useState, useRef } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import "../../../assets/styles/containers/_commentFilter.scss";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  Paper,
  Popper,
  Button,
  ButtonGroup,
  ClickAwayListener,
  Grow,
  MenuList,
  MenuItem,
} from "@mui/material";

const options = ["All", "Used", "Unused", "Deleted"];

function FilterButtonGroup({ GetCommentList, selectedFilterTagID, setState }) {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const matches = useMediaQuery("(max-width:640px)");

  // start on "All"
  const [selectedId, setSelectedId] = useState("All");
  const [selectedIndex, setSelectedIndex] = useState(0);

  const fireFilter = (label, index) => {
    setSelectedId(label);
    setSelectedIndex(index);

    const filterType = (label || "All").toLowerCase();
    // update parent state (resets page to 0)
    setState((prev) => ({
      ...prev,
      filterType,
      page: 0,
    }));
    // trigger parent fetch
    GetCommentList?.({
      filterByType: filterType,
      filterByTagId: selectedFilterTagID,
    });
  };

  const handleFilterButtonChange = (id, index) => fireFilter(id, index);

  const handleMenuItemClick = (_e, index, option) => {
    fireFilter(option, index);
    setOpen(false);
  };

  const handleToggle = () => setOpen((prev) => !prev);

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) return;
    setOpen(false);
  };

  return matches ? (
    <>
      <ButtonGroup
        variant="none"
        ref={anchorRef}
        aria-label="filters"
        className="button-grp-mobile"
      >
        <Button>
          <span style={{ marginLeft: 5 }}>{options[selectedIndex]}</span>
        </Button>
        <Button
          size="small"
          aria-controls={open ? "split-button-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="menu"
          onClick={handleToggle}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popper
        sx={{ zIndex: 99 }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {options.map((option, index) => (
                    <MenuItem
                      key={option}
                      selected={index === selectedIndex}
                      onClick={(e) => handleMenuItemClick(e, index, option)}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  ) : (
    <ButtonGroup variant="none" className="filter-button-group-container">
      {options.map((opt, idx) => {
        const isActive = selectedId === opt;
        return (
          <Button
            key={opt}
            variant="none"
            className={isActive ? "filter-button-tab-selected" : "filter-button-tab"}
            id={opt}
            onClick={() => handleFilterButtonChange(opt, idx)} // ✅ ENABLED
          >
            <span
              className={
                isActive
                  ? "filter-buttongrp-selected-textfield"
                  : "filter-buttongrp-textfield"
              }
            >
              {opt}
            </span>
          </Button>
        );
      })}
    </ButtonGroup>
  );
}

export default FilterButtonGroup;